export default __webpack_public_path__ + "static/media/quote.68bd9575.svg";